import { useContext } from "react"
import { Grid, Box } from "@mui/material"
import Icon from "@mdi/react"
import { mdiCheckDecagram } from "@mdi/js"

import AppContext, { AppContextState } from "@secureo/common/context/AppContext/AppContext"

import Button from "components/Buttons/Button"
import RatingStars from "components/RatingStars"

import useTranslation from "hooks/useTranslation"

import { makeStyles } from "makeStyles"

import { Review } from "@secureo/common/typings/Product"

const useStyles = makeStyles()(() => ({
	tabHeadline: {
		borderBottom: "5px solid #7abfac",
		marginBottom: "0",
		maxWidth: "90%",
	},
	tabHeadlineSecondBorder: {
		borderBottom: "1px solid lightgrey",
		marginBottom: "24px",
	},
	// single rating style
	rating: {
		display: "flex",
		justifyContent: "space-between",
		borderBottom: " 1px dotted lightgrey",
	},
	author: {
		color: "grey",
		fontStyle: "italic",
	},
}))

const Ratings = ({ reviews = [], averageRating }: Props) => {
	const { dispatch, isLoggedIn } = useContext(AppContext) as AppContextState
	const { t } = useTranslation("product")

	const { classes } = useStyles()
	const hasRatings = reviews.length > 0

	const toggleLoginRegisterFormIsOpen = () => {
		dispatch({
			type: "TOGGLE_LOGIN_REGISTER_FORM_IS_OPEN",
		})
	}

	const openLoginForm = () => {
		dispatch({
			type: "SET_OPEN_LOGIN_REGISTER_FORM_TAB",
			payload: "login",
		})
		toggleLoginRegisterFormIsOpen()
	}

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<div className={classes.tabHeadlineSecondBorder}>
					<h2 className={classes.tabHeadline}>
						{hasRatings
							? `${t("averageCustomerRating")} ${averageRating.toFixed(1)}`
							: t("noRatingsYet")}
					</h2>
				</div>
				<Grid container spacing={3}>
					{hasRatings && (
						<Grid item xs={12} md={6}>
							<RatingStars rating={averageRating} fontSize="small" />
							<div>{t("fromNRatings", { count: reviews.length })}</div>
						</Grid>
					)}
					<Grid item xs={12} md={hasRatings ? 6 : 12}>
						<div>
							<div>
								<strong>{t("doYouWantToRateThisProduct")}</strong>
							</div>
							<p>{t("doYouWantToRateThisProductText")}</p>
							{!isLoggedIn ? (
								<div style={{ maxWidth: "220px" }}>
									<Button color="primary" onClick={openLoginForm}>
										{t("login")}
									</Button>
								</div>
							) : (
								<div>{t("thisFunctionalityWillBeAvailableShortly")}</div>
							)}
						</div>
					</Grid>
					<Grid item xs={12}>
						<Box mt={4}>
							{reviews.map((review) => {
								const {
									id,
									authorName,
									title,
									text,
									rating,
									// createdAt,
									isVerifiedPurchaser,
								} = review

								return (
									<Box mt={3} key={id}>
										<div className={classes.rating}>
											<div>
												<strong>{title}</strong> -{" "}
												<span className={classes.author}>
													{authorName}
													{isVerifiedPurchaser && (
														<span>
															<Icon
																path={mdiCheckDecagram}
																size={0.5}
																color="#4691CE"
																style={{
																	marginLeft: 5,
																	marginRight: 5,
																}}
															/>
															{t("verifiedPurchase")}
														</span>
													)}
												</span>
											</div>
											<div style={{ textAlign: "right" }}>
												<RatingStars rating={rating} fontSize="small" />
											</div>
										</div>
										<Box my={2}>{text}</Box>
									</Box>
								)
							})}
						</Box>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

interface Props {
	averageRating: number
	reviews: Review[]
}

export default Ratings
